// Central translations + service catalog for Ashish Point
export const SERVICES = [
  { key: "aadhaar",     icon: "IdCard",       en: { title: "Aadhaar Card Assistance", desc: "New enrolment, update name/address/DOB, biometric help." }, hi: { title: "आधार कार्ड सहायता", desc: "नया आवेदन, नाम/पता/जन्मतिथि अपडेट, बायोमेट्रिक सहायता।" } },
  { key: "aadhaar_print", icon: "Printer",    en: { title: "Aadhaar Print", desc: "PVC / e-Aadhaar print and lamination." },                             hi: { title: "आधार प्रिंट", desc: "PVC / ई-आधार प्रिंट और लैमिनेशन।" } },
  { key: "passport",    icon: "BookUser",     en: { title: "Passport", desc: "New passport application, renewal, appointment booking." },                 hi: { title: "पासपोर्ट", desc: "नया पासपोर्ट, रिन्यूअल, अपॉइंटमेंट बुकिंग।" } },
  { key: "visa",        icon: "Plane",        en: { title: "Visa", desc: "Tourist / business visa filing and document preparation." },                    hi: { title: "वीज़ा", desc: "पर्यटक / व्यावसायिक वीज़ा फाइलिंग एवं दस्तावेज़ तैयारी।" } },
  { key: "voter_id",    icon: "Vote",         en: { title: "Voter ID", desc: "New voter ID, correction, address transfer." },                             hi: { title: "वोटर आईडी", desc: "नया वोटर आईडी, सुधार, पता स्थानांतरण।" } },
  { key: "caste_cert",  icon: "ScrollText",   en: { title: "Caste / Residence / Income Certificate", desc: "RTPS Bihar filing for all certificates." }, hi: { title: "जाति / निवास / आय प्रमाण-पत्र", desc: "बिहार RTPS पर सभी प्रमाण-पत्र फाइलिंग।" } },
  { key: "birth_cert",  icon: "Baby",         en: { title: "Birth Certificate", desc: "Municipal / panchayat birth certificate application." },           hi: { title: "जन्म प्रमाण-पत्र", desc: "नगर निगम / पंचायत जन्म प्रमाण-पत्र आवेदन।" } },
  { key: "flight",      icon: "PlaneTakeoff", en: { title: "Flight Ticket", desc: "Domestic and international flight booking at best fares." },           hi: { title: "फ्लाइट टिकट", desc: "घरेलू और अंतर्राष्ट्रीय उड़ान की सबसे बेहतर दर पर बुकिंग।" } },
  { key: "train",       icon: "TrainFront",   en: { title: "Train Ticket", desc: "IRCTC train ticket booking, tatkal, cancellation help." },              hi: { title: "ट्रेन टिकट", desc: "IRCTC ट्रेन टिकट बुकिंग, तत्काल, रद्दीकरण सहायता।" } },
  { key: "photo",       icon: "Camera",       en: { title: "Passport-Size Photo", desc: "Instant photo capture, print, digital passport photo." },        hi: { title: "पासपोर्ट साइज़ फोटो", desc: "तुरंत फोटो खिंचाई, प्रिंट, डिजिटल पासपोर्ट फोटो।" } },
  { key: "admission",   icon: "GraduationCap",en: { title: "Admission Form Filling", desc: "College / university / school online admission forms." },     hi: { title: "एडमिशन फॉर्म भरना", desc: "कॉलेज / विश्वविद्यालय / स्कूल ऑनलाइन एडमिशन फॉर्म।" } },
  { key: "scholarship", icon: "Award",        en: { title: "Scholarship Filing", desc: "NSP, MMS, e-Kalyan scholarship online application." },            hi: { title: "स्कॉलरशिप फाइलिंग", desc: "NSP, MMS, ई-कल्याण स्कॉलरशिप ऑनलाइन आवेदन।" } },
  { key: "dl",          icon: "Car",          en: { title: "Driving Licence", desc: "Learner / permanent DL, renewal, transfer applications." },          hi: { title: "ड्राइविंग लाइसेंस", desc: "लर्नर / परमानेंट DL, रिन्यूअल, ट्रांसफर आवेदन।" } },
  { key: "pan",         icon: "CreditCard",   en: { title: "PAN Card", desc: "New PAN, correction, e-PAN, Aadhaar linking." },                            hi: { title: "पैन कार्ड", desc: "नया पैन, सुधार, ई-पैन, आधार लिंकिंग।" } },
  { key: "epf",         icon: "Wallet",       en: { title: "EPF Claim / KYC", desc: "PF withdrawal, transfer, KYC update, UAN activation." },             hi: { title: "EPF दावा / KYC", desc: "PF निकासी, ट्रांसफर, KYC अपडेट, UAN सक्रिय।" } },
  { key: "other",       icon: "FilePlus",     en: { title: "Other Online Service", desc: "Have another government or online task? Tell us in the form." }, hi: { title: "अन्य ऑनलाइन सेवा", desc: "कोई और सरकारी या ऑनलाइन काम? फॉर्म में बताएं।" } },
];

export const t = {
  brand: { en: "Ashish Point", hi: "आशीष पॉइंट" },
  tagline: { en: "Trusted CSC & Online Services", hi: "विश्वसनीय CSC व ऑनलाइन सेवाएँ" },
  nav: {
    home:     { en: "Home", hi: "होम" },
    services: { en: "Services", hi: "सेवाएँ" },
    submit:   { en: "Submit Request", hi: "आवेदन करें" },
    track:    { en: "Track Request", hi: "स्थिति देखें" },
    branches: { en: "Branches", hi: "शाखाएँ" },
    privacy:  { en: "Privacy", hi: "गोपनीयता" },
    admin:    { en: "Admin", hi: "एडमिन" },
    partner:  { en: "Partner", hi: "पार्टनर" },
    staff:    { en: "Staff/Branch Login", hi: "स्टाफ/शाखा लॉगिन" },
    store:    { en: "AP Digital Store", hi: "AP डिजिटल स्टोर" },
  },
  hero: {
    kicker:  { en: "Common Service Centre · Bihar", hi: "कॉमन सर्विस सेंटर · बिहार" },
    title:   { en: "Government forms, done for you — locally, honestly, quickly.", hi: "सरकारी फॉर्म — आपके गाँव में, ईमानदारी से, जल्दी।" },
    subtitle:{ en: "From Aadhaar to PAN, passport to EPF — Ashish Point handles the paperwork so you can focus on life.", hi: "आधार से पैन तक, पासपोर्ट से EPF तक — आशीष पॉइंट कागज़ी काम संभालेगा, आप अपने जीवन पर ध्यान दें।" },
    ctaPrimary:  { en: "Apply for a Service", hi: "सेवा के लिए आवेदन" },
    ctaSecondary:{ en: "Track Your Request", hi: "स्थिति देखें" },
  },
  common: {
    apply:    { en: "Apply Now", hi: "अभी आवेदन करें" },
    call:     { en: "Call", hi: "कॉल करें" },
    whatsapp: { en: "WhatsApp", hi: "व्हाट्सएप" },
    submit:   { en: "Submit Request", hi: "आवेदन जमा करें" },
    submitting:{en: "Submitting…", hi: "जमा हो रहा है…" },
    name:     { en: "Full Name", hi: "पूरा नाम" },
    mobile:   { en: "Mobile Number", hi: "मोबाइल नंबर" },
    email:    { en: "Gmail / Email (optional)", hi: "जीमेल / ईमेल (वैकल्पिक)" },
    address:  { en: "Address", hi: "पता" },
    service:  { en: "Service", hi: "सेवा" },
    custom:   { en: "Describe your work (if selecting 'Other')", hi: "अपना काम बताएं (यदि 'अन्य' चुना है)" },
    notes:    { en: "Additional notes (optional)", hi: "अतिरिक्त नोट (वैकल्पिक)" },
    docs:     { en: "Upload Documents", hi: "दस्तावेज़ अपलोड करें" },
    docsHint: { en: "JPG, PNG or PDF — add as many as you need. Max 15 MB each.", hi: "JPG, PNG या PDF — जितने चाहें जोड़ें। प्रति फ़ाइल अधिकतम 15 MB।" },
    addMore:  { en: "Add more documents", hi: "और दस्तावेज़ जोड़ें" },
    remove:   { en: "Remove", hi: "हटाएं" },
    reqId:    { en: "Request ID", hi: "अनुरोध आईडी" },
    status:   { en: "Status", hi: "स्थिति" },
    updated:  { en: "Updated", hi: "अपडेट" },
    created:  { en: "Created", hi: "बनाया गया" },
    saveCopy: { en: "Please save your Request ID — you will need it to track your request.", hi: "कृपया अपनी अनुरोध आईडी सुरक्षित रखें — इसकी ज़रूरत स्थिति देखने में पड़ेगी।" },
  },
  track: {
    title:    { en: "Track Your Request", hi: "अपने आवेदन की स्थिति देखें" },
    subtitle: { en: "Enter your Application No. (Tracking ID).", hi: "अपना आवेदन नंबर (ट्रैकिंग आईडी) दर्ज करें।" },
    reqIdPh:  { en: "e.g. AP-A1B2C3", hi: "जैसे AP-A1B2C3" },
    check:    { en: "Check Status", hi: "स्थिति देखें" },
  },
  admin: {
    login:    { en: "Admin Login", hi: "एडमिन लॉगिन" },
    email:    { en: "Email", hi: "ईमेल" },
    password: { en: "Password", hi: "पासवर्ड" },
    signin:   { en: "Sign in", hi: "साइन इन" },
    dashboard:{ en: "Admin Dashboard", hi: "एडमिन डैशबोर्ड" },
    signout:  { en: "Sign out", hi: "साइन आउट" },
  },
  branches: {
    title:    { en: "Our Branches", hi: "हमारी शाखाएँ" },
    subtitle: { en: "Visit us in person or reach out on WhatsApp — we respond quickly.", hi: "हमारे पास आइए या व्हाट्सएप पर संपर्क करें — हम जल्दी जवाब देते हैं।" },
    miratola: { en: "Miratola Branch", hi: "मिरतोला शाखा" },
    dighwa:   { en: "Dighwa Dubauli Branch", hi: "डिघवा दुबौली शाखा" },
    operator: { en: "Operated by", hi: "संचालक" },
  },
  status: {
    "Received":            { en: "Received",            hi: "प्राप्त हुआ" },
    "Documents Checking":  { en: "Documents Checking",  hi: "दस्तावेज़ जाँच" },
    "In Process":          { en: "In Process",          hi: "प्रक्रियाधीन" },
    "Completed":           { en: "Completed",           hi: "पूर्ण" },
    "Rejected":            { en: "Rejected",            hi: "अस्वीकृत" },
    "Transferred":         { en: "Transferred",         hi: "स्थानांतरित" },
    "Assigned":            { en: "Assigned",            hi: "सौंपा गया" },
  },
  deadline: {
    "Same Day":            { en: "Same Day (Hand-to-Hand)", hi: "आज ही (हाथों-हाथ)" },
    "2 Days":              { en: "2 Days",                  hi: "2 दिन" },
    "5 Days":              { en: "5 Days",                  hi: "5 दिन" },
    "Custom":              { en: "Custom",                  hi: "अन्य" },
  },
  partner: {
    login:    { en: "Partner Login",    hi: "पार्टनर लॉगिन" },
    register: { en: "Become a Partner", hi: "पार्टनर बनें" },
    dashboard:{ en: "Partner Dashboard",hi: "पार्टनर डैशबोर्ड" },
    shopName: { en: "Shop Name",        hi: "दुकान का नाम" },
    autoLoc:  { en: "Auto-fetch shop location", hi: "दुकान का स्थान स्वतः प्राप्त करें" },
    pending:  { en: "Awaiting Admin Approval", hi: "एडमिन स्वीकृति का इंतज़ार" },
    accept:   { en: "Accept",           hi: "स्वीकारें" },
    reject:   { en: "Reject",           hi: "अस्वीकारें" },
    deadline: { en: "Choose Deadline",  hi: "समय-सीमा चुनें" },
    reason:   { en: "Reason",           hi: "कारण" },
    receipt:  { en: "Upload Receipt / Proof", hi: "रसीद / प्रमाण अपलोड करें" },
  },
};

export const STATUSES = ["Received", "Documents Checking", "In Process", "Completed", "Rejected", "Transferred", "Assigned"];
export const ADMIN_SET_STATUSES = ["Received", "Documents Checking", "In Process", "Completed", "Rejected"];
export const RETAILER_SET_STATUSES = ["In Process", "Completed"];
export const DEADLINES = ["Same Day", "2 Days", "5 Days", "Custom"];

export const BRANCHES = [
  {
    key: "miratola",
    name_en: "Miratola",
    name_hi: "मिरतोला",
    operator_en: "Anurag Kumar Sharma",
    operator_hi: "अनुराग कुमार शर्मा",
    mobile: "+917070335013",
    whatsapp: "917070335013",
    address_en: "Miratola, Bihar, India",
    address_hi: "मिरतोला, बिहार, भारत",
    mapEmbed: "https://www.google.com/maps?q=Miratola,Bihar,India&output=embed",
    mapUrl: "https://maps.app.goo.gl/oXiNGQveQseN4DT9A",
    hours_en: "Mon – Sat: 9:00 AM – 8:00 PM",
    hours_hi: "सोम – शनि: प्रातः 9:00 – रात्रि 8:00",
    hours_sunday_en: "Sunday: 10:00 AM – 4:00 PM",
    hours_sunday_hi: "रविवार: प्रातः 10:00 – अपराह्न 4:00",
  },
  {
    key: "dighwa",
    name_en: "Dighwa Dubauli",
    name_hi: "डिघवा दुबौली",
    operator_en: "Ranjit Kumar Sharma",
    operator_hi: "रंजित कुमार शर्मा",
    mobile: "+917070335050",
    whatsapp: "917070335050",
    address_en: "Dighwa Dubauli, Bihar, India",
    address_hi: "डिघवा दुबौली, बिहार, भारत",
    mapEmbed: "https://www.google.com/maps?q=Dighwa+Dubauli,Bihar,India&output=embed",
    mapUrl: "https://maps.app.goo.gl/WfBUHDmfrpq4XuJd8",
    hours_en: "Mon – Sat: 9:00 AM – 8:00 PM",
    hours_hi: "सोम – शनि: प्रातः 9:00 – रात्रि 8:00",
    hours_sunday_en: "Sunday: 10:00 AM – 4:00 PM",
    hours_sunday_hi: "रविवार: प्रातः 10:00 – अपराह्न 4:00",
  },
];

export const PRIMARY_WHATSAPP = "917070335050"; // Ranjit — main branch
export const PRIMARY_CALL = "+917070335050";
